import Title from '../title';
import styles from './style.module.css';

const PageContent = ({ title, children, className = '', as: Component = 'div' }) => (
    <Component className={`${styles.page_content} ${className}`}>
        {title && <Title title={title} className={styles.title} />}
        {children}
    </Component>
);

export default PageContent;
